import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { YearlyRevenueReport } from "~/modules/reports/api/revenueReport/revenueReportTypes.ts";

const revenueReportBasePath = "reports/revenue";

export function getYearlyRevenueReport(year: string): AxiosApiResponsePromise<YearlyRevenueReport> {
	return axiosApi.get(`${revenueReportBasePath}/${year}`);
}
